import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/initializers";
import VueMq from "vue-mq";
import "@/styles/app.scss";
import VueI18n from "vue-i18n";
import { I18N_MESSAGES } from "./utils/i18n";
import VImage from "@/components/Common/VImage.vue";
import VSvg from "@/components/Common/VSvg.vue";
import { DEFAULT_LANG } from "@/constants";

declare module "vue/types/vue" {
  interface Vue {
    $mq: string;
    $parseModel(list: any | any[]): any;
    $getModelRoutes(name: string): any;
    $getRoute(name: string): any;
    $httpGet(
      url: string,
      tag: string,
      fields?: string[] | string
    ): Promise<any>;
    $httpPost(url: string, tag: string, data: any): Promise<any>;
    $httpPut(url: string, tag: string, data: any): Promise<any>;
    $httpDelete(url: string, tag: string, data: any): Promise<any>;
    $isRouteActive(route: string): boolean;
    $areRouteActive(routes: string[]): boolean;
  }
}

Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    xs: 320,
    sm: 450,
    md: 998,
    lg: Infinity,
  },
  defaultBreakpoint: "sm", // customize this for SSR
});
Vue.component("v-img", VImage);
Vue.component("v-svg", VSvg);
export const bus = new Vue();
export const previewBus = new Vue();
Vue.config.productionTip = false;
Vue.config.silent = true;

// i18n config.
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: I18N_MESSAGES,
});
console.log(process.env)
new Vue({
  router,
  render: (h) => h(App),
  i18n,
}).$mount("#app");
